// import { Turbo } from "@hotwired/turbo-rails"
// import "core-js/stable"
// import "regenerator-runtime/runtime"


import { createRoot } from 'react-dom/client';
import { App } from '../portal/public_event/App';
import '../portal/styles/wysiwyg-buttons.css';
console.log('Vite ⚡️ Rails - Portal Public Event Entry Point Loaded');

// const initializeApplication = () => {
//   console.log('Vite ⚡️ Rails - Application Loaded')

//   if (!window.jQuery) {
//     console.error('jQuery failed to load properly')
//     return
//   }
// }

// Get the root element and parse props
const rootElement = document.getElementById("public-event-root");
if (rootElement) {
  const propsData = rootElement.dataset.props;
  let props: { style?: any; customCss?: string; analytics?: any; currentUser?: any } = {};

  if (propsData) {
    try {
      props = JSON.parse(propsData);
    } catch (e) {
      console.error('Failed to parse props:', e);
    }
  }

  // Log analytics configuration for debugging (only in development)
  if (process.env.NODE_ENV === 'development' && props.analytics) {
    console.log('[GTM] Analytics configuration loaded:', {
      gtmId: props.analytics.gtmId ? '***' + props.analytics.gtmId.slice(-4) : 'Not provided',
      googleAnalyticsId: props.analytics.googleAnalyticsId ? '***' + props.analytics.googleAnalyticsId.slice(-4) : 'Not provided'
    });
  }

  const root = createRoot(rootElement);
  root.render(<App {...props} />);
}

// document.addEventListener('turbo:load', initializeApplication)

// Turbo.start()
